export const graffitiConstants = {
    // Communes
    GRAFFITI_COMMUNES_FETCH_REQUEST: "GRAFFITI_COMMUNES_FETCH_REQUEST",
    GRAFFITI_COMMUNES_FETCH_SUCCESS: "GRAFFITI_COMMUNES_FETCH_SUCCESS",
    GRAFFITI_COMMUNES_FETCH_FAILURE: "GRAFFITI_COMMUNES_FETCH_FAILURE",

    // Quartiers
    GRAFFITI_QUARTIERS_FETCH_REQUEST: "GRAFFITI_QUARTIERS_FETCH_REQUEST",
    GRAFFITI_QUARTIERS_FETCH_SUCCESS: "GRAFFITI_QUARTIERS_FETCH_SUCCESS",
    GRAFFITI_QUARTIERS_FETCH_FAILURE: "GRAFFITI_QUARTIERS_FETCH_FAILURE",

    // Rues
    GRAFFITI_RUES_FETCH_REQUEST: "GRAFFITI_RUES_FETCH_REQUEST",
    GRAFFITI_RUES_FETCH_SUCCESS: "GRAFFITI_RUES_FETCH_SUCCESS",
    GRAFFITI_RUES_FETCH_FAILURE: "GRAFFITI_RUES_FETCH_FAILURE",

    // Metadata
    GRAFFITI_METADATA_FETCH_REQUEST: "GRAFFITI_METADATA_FETCH_REQUEST",
    GRAFFITI_METADATA_FETCH_SUCCESS: "GRAFFITI_METADATA_FETCH_SUCCESS",
    GRAFFITI_METADATA_FETCH_FAILURE: "GRAFFITI_METADATA_FETCH_FAILURE",

    // Single feature fetches (cache by ID)
    GRAFFITI_COMMUNE_FEATURE_FETCH_REQUEST: "GRAFFITI_COMMUNE_FEATURE_FETCH_REQUEST",
    GRAFFITI_COMMUNE_FEATURE_FETCH_SUCCESS: "GRAFFITI_COMMUNE_FEATURE_FETCH_SUCCESS",
    GRAFFITI_COMMUNE_FEATURE_FETCH_FAILURE: "GRAFFITI_COMMUNE_FEATURE_FETCH_FAILURE",
    GRAFFITI_QUARTIER_FEATURE_FETCH_REQUEST: "GRAFFITI_QUARTIER_FEATURE_FETCH_REQUEST",
    GRAFFITI_QUARTIER_FEATURE_FETCH_SUCCESS: "GRAFFITI_QUARTIER_FEATURE_FETCH_SUCCESS",
    GRAFFITI_QUARTIER_FEATURE_FETCH_FAILURE: "GRAFFITI_QUARTIER_FEATURE_FETCH_FAILURE",
    GRAFFITI_RUE_FEATURE_FETCH_REQUEST: "GRAFFITI_RUE_FEATURE_FETCH_REQUEST",
    GRAFFITI_RUE_FEATURE_FETCH_SUCCESS: "GRAFFITI_RUE_FEATURE_FETCH_SUCCESS",
    GRAFFITI_RUE_FEATURE_FETCH_FAILURE: "GRAFFITI_RUE_FEATURE_FETCH_FAILURE",

    // Clear data
    GRAFFITI_CLEAR_REQUEST: "GRAFFITI_CLEAR_REQUEST",
};